import type { Location } from 'react-router-dom';

const PREFERENCE_RESTORE_STATE_KEY = 'applyNavigationPreferencesOnLogin';
const NON_DEEP_LINK_LOGIN_TARGETS = ['/', '/procedures', '/uploads-dashboard'];

type LocationLike = Partial<Pick<Location, 'pathname' | 'search' | 'hash' | 'state'>>;

export interface NavigationPreferenceRestoreState {
  [PREFERENCE_RESTORE_STATE_KEY]?: boolean;
}

const isObjectRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && !Array.isArray(value);

export const isDeepLinkedLoginTarget = (target?: LocationLike | null) => {
  if (!target) {
    return false;
  }

  const pathname = target.pathname || '/';
  return Boolean(target.search || target.hash || !NON_DEEP_LINK_LOGIN_TARGETS.includes(pathname));
};

export const buildNavigationPreferenceRestoreState = (
  target?: LocationLike | null
): NavigationPreferenceRestoreState => ({
  ...(isObjectRecord(target?.state) ? target.state : {}),
  [PREFERENCE_RESTORE_STATE_KEY]: !isDeepLinkedLoginTarget(target),
});

export const shouldRestoreNavigationPreferencesOnRoute = (location: Pick<Location, 'state'>) => {
  const state = location.state;
  if (!isObjectRecord(state)) {
    return false;
  }

  return state[PREFERENCE_RESTORE_STATE_KEY] === true;
};
